module.exports = __webpack_public_path__ + "img/fundingResolutionLogo5.12152b3a.png";